import React from 'react';
import ReactDOM from 'react-dom';

// the app
import {Toolbar} from './components/Toolbar';

// styles
import './styles/css/styles.css?v=06';

ReactDOM.render(<Toolbar />, document.getElementById('root'));